(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-icons-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const initSlider = (list) => {
      if (!list || !list.hasAttribute('data-feature-icons-slider') || list.children.length < 2) {
        return;
      }

      let index = 0;
      let timer;
      const autoRotate = list.dataset.mobileAutorotate === 'true';
      const interval = Number(list.dataset.mobileAutorotateSpeed) || 4000;

      const goTo = (nextIndex) => {
        index = nextIndex % list.children.length;
        list.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      };

      const start = () => {
        if (!autoRotate || !mobileQuery.matches) {
          return;
        }
        stop();
        timer = window.setInterval(() => {
          goTo(index + 1);
        }, interval);
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
        }
      };

      const handleViewportChange = () => {
        if (!mobileQuery.matches) {
          stop();
          index = 0;
          list.style.transform = '';
          return;
        }
        goTo(index);
        start();
      };

      handleViewportChange();
      mobileQuery.addEventListener('change', handleViewportChange);
      list.addEventListener('mouseenter', stop);
      list.addEventListener('mouseleave', start);
      list.addEventListener('touchstart', stop, { passive: true });
      list.addEventListener('touchend', start, { passive: true });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-feature-icons-slider]').forEach(initSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strips"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const initSlider = (list) => {
      if (!list || !list.hasAttribute('data-trust-strip-slider') || list.children.length < 2) {
        return;
      }

      let index = 0;
      let timer;
      const autoRotate = list.dataset.mobileAutorotate === 'true';
      const interval = Number(list.dataset.mobileAutorotateSpeed) || 4000;

      const goTo = (nextIndex) => {
        index = nextIndex % list.children.length;
        list.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      };

      const start = () => {
        if (!autoRotate || !mobileQuery.matches) {
          return;
        }
        stop();
        timer = window.setInterval(() => {
          goTo(index + 1);
        }, interval);
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
        }
      };

      const handleViewportChange = () => {
        if (!mobileQuery.matches) {
          stop();
          index = 0;
          list.style.transform = '';
          return;
        }
        goTo(index);
        start();
      };

      handleViewportChange();
      mobileQuery.addEventListener('change', handleViewportChange);
      list.addEventListener('mouseenter', stop);
      list.addEventListener('mouseleave', start);
      list.addEventListener('touchstart', stop, { passive: true });
      list.addEventListener('touchend', start, { passive: true });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-trust-strip-slider]').forEach(initSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
